import { magicNumbers } from 'utils';

export const telegramInitialState = {
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      member_count: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:memberCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    hasActivateSwitch: true,
  },
  sortResourcesBy: {
    title: 'filter:sortBasedOnResult',
    hasFilter: false,
    isOpen: false,
    selected: 'member_count',
    order: 'desc',
    platform: 'news',
    componentName: 'sortResourcesBy',
    translateKey: 'filter:resourceCategory',
  },
};
